import { AfterViewInit, ElementRef, } from '@angular/core';
import { Component } from '@angular/core';
import { AngularFireList } from '@angular/fire/database';
import { Observable } from 'rxjs';

  //

  //Tu tranquilo yo nervioso, lo que hay que cambiar es el templateURL y el constructor 

@Component({
  selector: 'app-root',
  templateUrl:'./app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'login';

  itemsRef: AngularFireList<any>;
  items: Observable<any[]>;

  constructor(private elementRef: ElementRef,  ){ }
  
  ngAfterViewInit(){
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'yellow';
 }
  

  
}


